import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g
        data-name="Layer 1"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 20.41v-5.86C14 12.07 11.69 10 8.89 10h-3.3C2.79 10 .5 12 .5 14.51v5.86z" />
        <ellipse cx={7.24} cy={5.4} rx={4.94} ry={4.9} />
        <path d="M40.5 23.17V17c0-2.6-2.4-4.73-5.33-4.73h-3.46c-2.93 0-5.33 2.13-5.33 4.73v6.13z" />
        <ellipse cx={33.44} cy={7.45} rx={5.17} ry={5.13} />
        <path d="M27.1 40.5v-7.58c0-3.21-3-5.84-6.58-5.84h-4.28c-3.62 0-6.58 2.63-6.58 5.84v7.58z" />
        <ellipse cx={18.38} cy={21.09} rx={6.39} ry={6.34} />
      </g>
    </g>
  </svg>
);

const Users = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Users;
